import React, { useMemo } from "react";
import { useQuery, useMutation } from "@apollo/client";
import {
  GET_BATCH_BY_ID,
  UPDATE_BATCH_DETAILS,
} from "../../../GraphQl/Queries/BatchesQueries";
import { Form } from "skillstrainer-resource-library";
import Container from "components/Container/Container";
import BatchFormBuilder from "formBuilders/UpdateBatchFormBuilder";
import { successHandler, errorHandler } from "utils/toast";

const UpdateBatch = ({ batchData, close }) => {
  const { id } = batchData;
  console.log("id", id);

  // Fetch batch details
  const { data: querydata, loading } = useQuery(GET_BATCH_BY_ID, {
    variables: { id },
  });

  // Mutation for updating batch
  const [updateBatch, { loading: updating }] = useMutation(
    UPDATE_BATCH_DETAILS,
    {
      onCompleted: () => {
        successHandler("Batch updated successfully!");
        close(); // close modal after update
      },
      onError: (err) => {
        errorHandler(err.message);
      },
    },
  );

  const batch = useMemo(() => {
    const b = querydata?.courses_course_batches[0];
    if (!b) return null;
    return {
      ...b,
      partner_id: b.partner?.id ?? null,
      project_id: b.project?.id ?? null,
    };
  }, [querydata]);

  const submitBatch = async (batch_data) => {
    console.log("batch_data", batch_data);

    await updateBatch({
      variables: {
        id,
        batch_name: batch_data?.batch_name,
        from_date: batch_data.from_date,
        to_date: batch_data.to_date,
        registration_end_date: batch_data.registration_end_date,
        max_learners: batch_data.max_learners,
        instructor_id: batch_data.instructor_id
          ? parseInt(batch_data.instructor_id)
          : null,
        course_id: batch_data.course_id ? parseInt(batch_data.course_id) : null,
        language_id: batch_data.language_id
          ? parseInt(batch_data.language_id)
          : null,
        slot_start_time: batch_data.slot_start_time,
        slot_end_time: batch_data.slot_end_time,
        partner_id: batch_data.partner_id
          ? parseInt(batch_data.partner_id)
          : null,
        project_id: batch_data.project_id
          ? parseInt(batch_data.project_id)
          : null,
      },
    });
  };

  if (loading) return <p>Loading...</p>;

  return (
    <Container title={"Update Batch"}>
      <strong className="text-right">Seats Available:</strong>{" "}
      {batch.max_learners -
        batchData?.userEnrollmentBatchArray_aggregate?.aggregate.count}
      {batch && (
        <Form
          formBuilder={BatchFormBuilder}
          initValues={batch}
          className="ml-6 mt-2 grid grid-cols-2 gap-x-2"
          submitButton={{
            text: updating ? "Saving..." : "Save",
            className:
              "btn-primary bg-orange text-sm font-semibold text-white rounded-md px-6",
          }}
          onSubmit={(values) => submitBatch(values)}
        />
      )}
    </Container>
  );
};

export default UpdateBatch;
